import { UrlConstants } from "../url.constants";
export class ApiInvoiceConstants {
    static URL = UrlConstants.API_V2 + "Invoice";
    static GetVatPercentage = "GetVatPercentage";
}
